var map = {
	"./bg-exclusive.webp": 1349,
	"./border-bg-sm.png": 1350,
	"./border-bg-xm.png": 1351,
	"./border-bg.png": 1352,
	"./btn-active.png": 1353,
	"./casino-hover.webp": 1354,
	"./cny-flower-1.webp": 1355,
	"./cny-flower-2.webp": 1356,
	"./cny-mobile-bg.webp": 1357,
	"./content-deco-1.webp": 1358,
	"./content-deco-2.webp": 1359,
	"./content-deco-3.webp": 1360,
	"./content-deco-4.webp": 1361,
	"./content-deco-5.webp": 1362,
	"./deposit-icon.webp": 1363,
	"./event-border-hover.webp": 1364,
	"./games-hover.webp": 1365,
	"./home-icon-active.webp": 1366,
	"./home-icon.webp": 1367,
	"./live-icon-active.webp": 1368,
	"./live-icon.webp": 1369,
	"./lottery-hover.webp": 1370,
	"./master-bg.png": 1371,
	"./me-icon-active.webp": 1372,
	"./me-icon.webp": 1373,
	"./p2p-hover.webp": 1374,
	"./platform.webp": 1375,
	"./product-overview-bg.webp": 1376,
	"./promos-icon-active.webp": 1377,
	"./promos-icon.webp": 1378,
	"./slots-hover.webp": 1379,
	"./sponsor-icon-active.webp": 1380,
	"./sponsor-icon.webp": 1381,
	"./sports-hover.webp": 1382,
	"./title-deco-bg.webp": 1383,
	"./title-deco-left.webp": 1384,
	"./title-deco-right.webp": 1385,
	"./vip-icon-active.webp": 1386,
	"./vip-icon.webp": 1387,
	"./withdraw-icon.webp": 1388,
	"./wwr-bg.webp": 1389,
	"./wwr-img.webp": 1390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;